import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './containers/App';
import registerServiceWorker from './registerServiceWorker';
import initialize from './common/init';

initialize.then(() => {
    console.log('initialized');
    ReactDOM.render(<App />, document.getElementById('root'));
    registerServiceWorker();
});




// WEBPACK FOOTER //
// ./src/index.js